<template>
  <!--添加备注-->
  <el-dialog
    :append-to-body="true"
    :title="$t('receivablePayable.AddANote')"
    :visible.sync="showAddNotes"
    width="50%"
    @close="remarks = ''"
  >
    <el-input v-model="remarks" :rows="5" type="textarea" />
    <span slot="footer" class="dialog-footer">
      <!--取 消-->
      <el-button @click="colsDialog">{{ $t('basicData.Cancel') }}</el-button>
      <!--确 定-->
      <el-button type="primary" @click="saveRemarks">{{ $t('basicData.determine') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { apiSetRemark } from '@/api/finance/receivables';

export default {
  name: 'RemarkDialog',

  props: {
    selectData: {
      type: Array,
      default: () => []
    },
    queryForm: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      showAddNotes: false,
      remarks: ''
    };
  },

  methods: {
    open() {
      this.showAddNotes = true;
    },
    colsDialog() {
      this.showAddNotes = false;
      this.remarks = '';
    },
    saveRemarks() {
      const ids = this.selectData.map(item => item.id);

      if (!this.remarks) {
        this.$message.warning(this.$t('receivablePayable.TheCommentCannotBeEmpty')); // '备注不能为空'
        return;
      }

      const param = {
        condition: this.queryForm,
        remark: this.remarks
      };
      param.condition.ids = ids;
      apiSetRemark(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.remarks = '';
          this.colsDialog();

          this.$emit('change');
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>

</style>
